// extracted by mini-css-extract-plugin
export default {"container":"StationRoot_container__7YcXg"};